import { Injectable, inject } from '@angular/core';
import { FormID } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import { ZonePageUrlProvider } from '../../../Modules/zones/zone-url-provider';
import { SetFormActionWithId } from '../../actions/form-submission.action';
import { FormActionState } from '../../state/form-submision.state';
import { flattenObject } from '../../utils/utils';
import { WorkflowFormsService } from '../workflow-forms/workflow-forms.service';

@Injectable({ providedIn: 'root' })
export class OnboardingDetailsService {
  private readonly forms = inject(WorkflowFormsService);
  private readonly store = inject(Store);
  private readonly alerts = inject(AlertHandlerService);

  validateAndSaveDetails(formID: string, zone: ZonePageUrlProvider): Record<string, any> | undefined {
    const validation = this.forms.validateCurrentPageForms();
    if (!validation.isValid) {
      this.forms.markCurrentPageFormsTouched();
      if (validation.invalidForms?.length !== 0) return;
    }
    const currentForms: Record<string, any> = {};
    for (const id of this.forms.getCurrentPageForms()) {
      const value = this.forms.getFormValues(id);
      if (value) currentForms[id] = value;
    }
    const values = flattenObject(currentForms);
    if (
      ('isEmailVerified' in values && !values['isEmailVerified']) ||
      ('isPhoneVerified' in values && !values['isPhoneVerified'])
    ) {
      this.alerts.showAlertFn('error', 'Email or phone not verified.');
      return;
    }
    const formId = this.forms.generateCustomFormId(formID, zone);
    if (this.forms.getFormPart(formId)) {
      this.store.dispatch(
        new SetFormActionWithId({ type: '', formData: currentForms[formId] || {} }, formID),
      );
    }
    const persisted =
      this.store.selectSnapshot(FormActionState.getFormActionStateWithId(FormID.ONBOARDING_FLOW))?.formData ||
      {};
    return { ...persisted, ...values, ...currentForms[formId] };
  }
}
